import cx from "classnames";
import { useNavigate } from "react-router-dom";

import { Button } from "atoms/button/Button";

type BannerCTAProps = {
  title: string;
  description: string;
  callToActionText: string;
  navigateTo: string;
  imageUrl?: string;
  homeStyle?: boolean;
};
const BannerCTA = (props: BannerCTAProps) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(props.navigateTo);
  };
  return (
    <div
      className={cx(
        "flex flex-col items-center bg-cover bg-center text-white",
        !props.homeStyle ? "h-[360px]" : "-mt-3 aspect-[390/434] p-8"
      )}
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.2) 12%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 55%, rgba(0, 0, 0, 0.25) 80%), url(${props.imageUrl})`,
      }}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      <div className="mt-10 text-center font-serif text-display text-shadow">
        {props.title}
      </div>

      {props.description && (
        <div className="sticky top-[244px] text-center text-body2 text-shadow">
          {props.description}
        </div>
      )}
      {props.callToActionText && (
        <div className="sticky top-[278px] min-w-[158px] whitespace-nowrap text-center">
          <Button style="outline" size="medium" fullWidth>
            {props.callToActionText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default BannerCTA;
